import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

const WipSummaryFollowUpDialog = props => {
  const { open, onClose, currentSummary, onSubmit, loading } = props
  const [instruction, setInstruction] = useState('')

  const handleClose = () => {
    if (!loading) {
      setInstruction('')
      onClose()
    }
  }

  const handleSubmit = async () => {
    const trimmed = instruction.trim()
    if (!trimmed || loading) return
    await onSubmit(trimmed)
    setInstruction('')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Refine summary with AI</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          Current summary
        </Typography>
        <Typography
          variant="body2"
          component="pre"
          style={{
            whiteSpace: 'pre-wrap',
            maxHeight: 160,
            overflow: 'auto',
            padding: 12,
            background: '#f5f5f5',
            borderRadius: 4,
            marginBottom: 16,
            fontFamily: 'inherit',
          }}
        >
          {currentSummary || '(empty)'}
        </Typography>
        <TextField
          autoFocus
          label="Instructions for the LLM"
          placeholder="e.g. Shorten the second paragraph and emphasize budget pacing…"
          fullWidth
          multiline
          minRows={4}
          variant="outlined"
          value={instruction}
          onChange={e => setInstruction(e.target.value)}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !instruction.trim()}
        >
          {loading ? 'Applying…' : 'Apply'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

WipSummaryFollowUpDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentSummary: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

WipSummaryFollowUpDialog.defaultProps = {
  currentSummary: '',
  loading: false,
}

export default WipSummaryFollowUpDialog
